import State from 'interfaces/state/State';

export const isLoading$ = (state: State) => state.registerFromInvite.isError;
export const isError$ = (state: State) => state.registerFromInvite.isError;
export const isSuccess$ = (state: State) => state.registerFromInvite.isSuccess;
